import React, { useEffect, useState } from "react";
import { Form, Button, DatePicker, Switch } from "antd";
import { IteamFormModal } from "./IteamFormModal";
import { useCheckFormMultiple } from "../../../hooks/useCheckFormMultiple";
import dayjs from "dayjs";
import { FormEditPauses } from "./FormEditPauses";
import { typesPauses } from "../../../types/typePauses";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";
import { ContainerModal } from "../../container/ContainerModal";

const dateFormat = "YYYY/MM/DD";

export const FormCalendar = ({ dataForm = {}, pauses = [], reasons = [], isActivePauses = false, editFormForProjectDetails, closeModalDetails, activeModalDetailsProject }) => {

	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);

	const { checkValues, onChangueValue } = useCheckFormMultiple({
		isTimeDeadLine: false,
	});

	const [selectPauseInput, setSelectPauseInput] = useState({ indexPause: -1, isDelete: false });
	const [whatTimeShow, setWhatTimeShow] = useState(false);

	const checkTime = () => {
		let eitherOr = -1;
		if (dataForm.deadLineDate !== "" && eitherOr === -1) {
			onChangueValue("isTimeDeadLine", true);
			setWhatTimeShow(true);
			eitherOr = 1;
		}

		if (dataForm.estimatedClosingDate !== "" && eitherOr === -1) {
			onChangueValue("isTimeDeadLine", false);
			setWhatTimeShow(true);
			eitherOr = 2;
		}
	};

	useEffect(() => {
		checkTime();

		const pauseArray = pauses.map(({ init, close, reasons }) => {
			return {
				init: dayjs(init, dateFormat),
				close: close === "" ? "" : dayjs(close, dateFormat),
				reason: reasons.map((r) => r.reason),
			};
		});

		form.setFieldsValue({
			deadLine: dataForm.deadLineDate === "" ? "" : dayjs(dataForm.deadLineDate, dateFormat),
			expectedCloseDate: dataForm.estimatedClosingDate === "" ? "" : dayjs(dataForm.estimatedClosingDate, dateFormat),
			pausesData: pauseArray,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const setPauseForm = async (pausesData) => {
		setLoading(true);

		const { _id = null } = pauses[selectPauseInput.indexPause];
		const { init, close, reason } = pausesData[selectPauseInput.indexPause];
		const reasonsId = reasons.filter((element) => reason.includes(element.name)).map((reason) => reason._id);
		let jsonForm = {};
		if (selectPauseInput.isDelete) {
			jsonForm = {
				typePauseSelect: typesPauses.deletePause,
				id: _id,
			};
		} else {
			jsonForm = {
				typePauseSelect: typesPauses.editPause,
				id: _id,
				initDate: init,
				finishDate: close,
				reasonsId,
			};
		}
		jsonForm.isPause = true;

        await editFormForProjectDetails(typeForDetailsProyect.pauses, jsonForm);

        setLoading(false);
	};

	const finishForm = async ({ expectedCloseDate, deadLine, pausesData }) => {
		if (selectPauseInput.indexPause > -1) {
			await setPauseForm(pausesData);
			return;
		}

		setLoading(true);

		if (!checkValues.isTimeDeadLine && !expectedCloseDate) return;
		if (checkValues.isTimeDeadLine && !deadLine) return;

		const selectDate = checkValues.isTimeDeadLine ? deadLine.format("YYYY-MM-DD") : expectedCloseDate.format("YYYY-MM-DD");

		const structureJson = checkValues.isTimeDeadLine ? { deadLine: selectDate } : { expectedDate: selectDate };

        await editFormForProjectDetails(typeForDetailsProyect.calendar, structureJson);

        setLoading(false);
	};

	return (
		<>
			<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
				<ContainerModal
					title={"Editar calendario"}
					actionButton={() => {
						closeModalDetails();
					}}
					className={"w-[500px]"}
				>
					<Form form={form} onFinish={finishForm} className="w-full h-full">
						<div>
							<IteamFormModal title="Fechas">
								<div className={`grid gap-2 ${whatTimeShow ? "grid-cols-1" : "grid-cols-[120px_40px_calc(100%-160px)]"} `}>
									{whatTimeShow ? (
										<>
											<p className="text-[10px]">
												{checkValues["isTimeDeadLine"] ? "Fecha limite de entrega" : "Fecha estimada de cierre"}
											</p>
										</>
									) : (
										<>
											<p className="text-[10px]">Fecha limite de entrega</p>
											<Switch
												checked={checkValues["isTimeDeadLine"]}
												onChange={(value) => {
													onChangueValue("isTimeDeadLine", value);
												}}
												size="small"
												className={`${checkValues["isTimeDeadLine"] ? "bg-primaryTwo" : "bg-[#CDCDCD]"}`}
											/>
											<p className="text-[10px]">
												{checkValues["isTimeDeadLine"] ? "Fecha limite de entrega" : "Fecha estimada de cierre"}
											</p>
											<div />
											<div />
										</>
									)}
									<div className="">
										<Form.Item name={`${checkValues["isTimeDeadLine"] ? "deadLine" : "expectedCloseDate"}`} className="h-[10px]">
											<DatePicker format={dateFormat} size="small" />
										</Form.Item>
									</div>
								</div>
							</IteamFormModal>
							<IteamFormModal title="Pausa">
								<div className="max-h-[550px] overflow-y-scroll scroll-project-details">
									<FormEditPauses
										selectPauseInput={selectPauseInput}
										setSelectPauseInput={setSelectPauseInput}
										pauses={pauses}
										finishForm={() => {
											finishForm(form.getFieldValue());
										}}
										reasons={reasons}
										isActivePauses={isActivePauses}
									/>
								</div>
								<Button
									onClick={() => {
										activeModalDetailsProject(typeForDetailsProyect.pauses, { type: typesPauses.createPauseRange });
									}}
									htmlType="button"
									disabled={isActivePauses}
								>
                                    Agregar pausa
								</Button>
							</IteamFormModal>
						</div>
						<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
							<Button htmlType="button" onClick={closeModalDetails}>
								Cancelar
							</Button>
							<Button type="primary" htmlType="submit" className="bg-primaryTwo" loading={loading}>
								Guardar
							</Button>
						</div>
					</Form>
				</ContainerModal>
			</div>
		</>
	);
};
